import { ChangeDetectorRef, Component, OnInit, ViewChild, Injectable, NgModule } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { DevicePilomat } from '../model/devicePilomat';
import { Log } from '../util/log';
import { FormControl, FormGroup } from "@angular/forms";
import { DateHelper } from '../util/dateHelper';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { NumberLiteralType } from 'typescript';
import { DateAdapter } from '@angular/material/core';
import { Overlay } from "@angular/cdk/overlay";
import { UserService } from '../service/user.service';
import { operationLogEvent } from '../model/operationLogEvent';
import { AppComponent } from '../app.component';
import { StringHelper } from '../util/stringHelper';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';



@Component({
  selector: 'app-operation-log',
  templateUrl: './operation-log.component.html',
  styleUrls: ['./operation-log.component.css']
})
export class OperationLogComponent implements OnInit {

  @ViewChild('logloader', { static: true }) loader;
  @ViewChild('logtable', { static: true }) table;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  filterGroup = new FormGroup({
    operatorInput: new FormControl(''),
    serialInput: new FormControl('')
  });

  ownerUid: string = "";

  fromFormControl: FormControl;
  toFormControl: FormControl;

  logDateTo: Date;
  logDateFrom: Date;
  showDatePickers: Boolean = false;
  displayedColumns: string[] = ['date', 'operator', 'serial', 'data', 'result'];

  logList: operationLogEvent[];
  dataSource: MatTableDataSource<operationLogEvent>;
  filterString: string = "";

  pageEvent: PageEvent;
  pageSize: number = 200;
  maxPages: number = 0;
  pageLength: number = 0;
  tableItemsTotalCounter: number = 0;
  pageSizeOptions: number[] = [200];
  currentPage: number = 0;

  deviceLogString = $localize`:@@operationLog_device_log: Log dispositivo`;
  accessLogString = $localize`:@@operationLog_access_log: Registro accessi`;

  placeholderString = $localize`:@@operationLog_placeholder:operatore@gestore.it`;

  

  searchFilter: string = "2";
  //1 = none | 2 = Operator | 3 = Serial

  operatorInput: string = "";
  enableOperator: boolean = false;
  serialInput: string = "";
  enableSerial: boolean = true;


  constructor(
    public appComponent: AppComponent,
    private userService: UserService,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private overlay: Overlay,
    private dateAdapter: DateAdapter<any>) {
    this.dateAdapter.setLocale($localize`:@@devicelog_datepicker_locale:it`);

  }

  ngOnInit() {

  }

  ngAfterViewInit() {

    this.userService.getMe().subscribe((owner) => {
      this.ownerUid = owner.uid
    });

    this.logDateTo = new Date();
    this.logDateFrom = new Date();
    this.logDateTo.setHours(23, 59);
    this.logDateFrom.setHours(0, 0);

    this.toFormControl = new FormControl(this.logDateTo);
    this.fromFormControl = new FormControl(this.logDateFrom);

    if (this.isService() || this.isAdmin()) {

      Log.debug("\n\n is in this.isService() || this.isAdmin()")

      //Se è service o admin viene nascosto il tasto "tutti" e non faccio alcuna chiamata iniziale

      this.loader.hideLoading();

    } else {

      this.searchFilter = "1";

      setTimeout(() => {

        // this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo));
        this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);
      });
    }
  }

  isService(): boolean {
    return this.appComponent.isService();
  }

  isAdmin(): boolean {
    return this.appComponent.isAdmin();
  }

  setLogTimeRange(picked: any) {
    // this.pickedTimeRangeValue = picked.value;

    if (picked.value == "1") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();
      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);
      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);

      // +(this.logDateFrom.getTimezoneOffset()/60).toString()
      // +(this.logDateTo.getTimezoneOffset()/60).toString()

      Log.debug(DateHelper.formatDateForApi(this.logDateFrom));
      Log.debug(this.logDateFrom.getTimezoneOffset());
      Log.debug(DateHelper.formatDateForApi(this.logDateTo))
      Log.debug(this.logDateTo.getTimezoneOffset())
    } else if (picked.value == "2") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();

      this.logDateTo.setDate(this.logDateTo.getDate() - 1);
      this.logDateFrom.setDate(this.logDateFrom.getDate() - 1);

      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);
      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);

      Log.debug(DateHelper.formatDateForApi(this.logDateFrom));
      Log.debug(DateHelper.formatDateForApi(this.logDateTo))
    } else if (picked.value == "3") {
      this.showDatePickers = true;
    }
  }

  setLogFilter(picked: any) {
    if (picked.value == "1") {
      this.searchFilter = "1";
      Log.debug("1");
      this.enableOperator = true;
      this.enableSerial = true;
      this.operatorInput = "";
      this.serialInput = "";
    } else if (picked.value == "2") {
      this.searchFilter = "2";
      Log.debug("2");
      this.enableOperator = false;
      this.enableSerial = true;
      this.operatorInput = "";
      this.serialInput = "";
    } else if (picked.value == "3") {
      this.searchFilter = "3";
      Log.debug("3");
      this.enableOperator = true;
      this.enableSerial = false;
      this.operatorInput = "";
      this.serialInput = "";
    }
  }

  confirmDateSelection() {
    if (this.showDatePickers) {
      if (this.fromFormControl.value) {
        this.logDateFrom = new Date(this.fromFormControl.value);
      }
      if (this.toFormControl.value) {
        this.logDateTo = new Date(this.toFormControl.value);
      }
      this.logDateTo.setHours(23, 59, 59)
      this.logDateFrom.setHours(0, 0, 0)
    }

    this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);

  }

  onKey(event: any) {

    this.filterString = event.target.value;

    this.table.dataSource.filter = this.filterString.trim().toLowerCase();
  }

  filterTable(data: operationLogEvent, filter: string): boolean {
    if (data.operator && data.operator.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.serial && data.serial.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.data && data.data.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.result && data.result.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    return false;
  }

  replaceAt(original, index) {
    const words = original.split(' ');
    words[index] = StringHelper.censorString(words[index]);
    return words.join(' ');
  };

  loadData(dateFrom: string, dateTo: string, page: number) {
    this.loader.showLoading();

    this.currentPage = page;

    if (this.searchFilter == "1") {
      Log.debug('filter = 1');

      this.userService.getOperationLogCount(this.ownerUid, dateFrom, dateTo).subscribe(data => {

        this.tableItemsTotalCounter = data.count;
        this.maxPages = Math.ceil(data.count / this.pageSize);

        Log.debug("getLogCount - tableItemsTotalCounter:  " + this.tableItemsTotalCounter + "  maxPages:" + this.maxPages);

        const obs = this.userService.getOperations(this.ownerUid, dateFrom, dateTo, page);
        obs.subscribe(data => {

          if (this.isService()) {
            data = this.censorData(data);
          }

          this.logList = data;

          this.table.dataSource = new MatTableDataSource(this.logList);
          this.table.dataSource.filterPredicate = this.filterTable;
          this.table.dataSource.sort = this.sort;
          this.table.dataSource.filter = this.filterString.trim().toLowerCase();
          this.cdRef.detectChanges();

          this.loader.hideLoading();

        }, error => {
          Log.debug("err:");
          Log.debug(error);
          this.loader.hideLoading();
          this.loader.showError();
        });

      }, error => {
        Log.debug("err:");
        Log.debug(error);

        if (error.error.code == 401) {
          this.loader.hideLoading();
          Log.debug("\n\n\t Non sei autorizzato");
          this.unauthDialog();

        } else {
          this.loader.hideLoading();
          this.loader.showError();
        }
      });

    } else if (this.searchFilter == "2") {
      Log.debug('filter = 2');
      Log.debug(this.operatorInput);
      this.userService.getOperationLogByOperatorCount(this.ownerUid, this.operatorInput, dateFrom, dateTo).subscribe(data => {

        this.tableItemsTotalCounter = data.count;
        this.maxPages = Math.ceil(data.count / this.pageSize);

        Log.debug("getLogCount - tableItemsTotalCounter:  " + this.tableItemsTotalCounter + "  maxPages:" + this.maxPages);

        const obs = this.userService.getOperationsByOperator(this.ownerUid, this.operatorInput, dateFrom, dateTo, page);
        obs.subscribe(data => {

          if (this.isService()) {
            data = this.censorData(data);
          }
          this.logList = data;

          this.table.dataSource = new MatTableDataSource(this.logList);
          this.table.dataSource.filterPredicate = this.filterTable;
          this.table.dataSource.sort = this.sort;
          this.table.dataSource.filter = this.filterString.trim().toLowerCase();
          this.cdRef.detectChanges();

          this.loader.hideLoading();

        }, error => {
          Log.debug("err:");
          Log.debug(error);
          this.loader.hideLoading();
          this.loader.showError();
        });

      }, error => {
        Log.debug("err:");
        Log.debug(error);
        if (error.error.code == 401) {
          this.loader.hideLoading();
          Log.debug("\n\n\t Non sei autorizzato");
          this.unauthDialog();


        } else {
          this.loader.hideLoading();
          this.loader.showError();
        }
      });

    } else if (this.searchFilter == "3") {
      Log.debug('filter = 3');
      Log.debug(this.serialInput);
      this.userService.getOperationLogBySerialCount(this.ownerUid, this.serialInput, dateFrom, dateTo).subscribe(data => {

        this.tableItemsTotalCounter = data.count;
        this.maxPages = Math.ceil(data.count / this.pageSize);

        Log.debug("getLogCount - tableItemsTotalCounter:  " + this.tableItemsTotalCounter + "  maxPages:" + this.maxPages);

        const obs = this.userService.getOperationsBySerial(this.ownerUid, this.serialInput, dateFrom, dateTo, page);
        obs.subscribe(data => {

          if (this.isService()) {
            data = this.censorData(data);
          }

          this.logList = data;

          this.table.dataSource = new MatTableDataSource(this.logList);
          this.table.dataSource.filterPredicate = this.filterTable;
          this.table.dataSource.sort = this.sort;
          this.table.dataSource.filter = this.filterString.trim().toLowerCase();
          this.cdRef.detectChanges();

          this.loader.hideLoading();

        }, error => {
          Log.debug("err:");
          Log.debug(error);
          this.loader.hideLoading();
          this.loader.showError();
        });
      }, error => {
        Log.debug("err:");
        Log.debug(error);
        if (error.error.code == 401) {
          this.loader.hideLoading();
          Log.debug("\n\n\t Non sei autorizzato");
          this.unauthDialog();

        } else {
          this.loader.hideLoading();
          this.loader.showError();
        }
      });
    } else {
      Log.debug("searchfilter error");
      Log.debug(this.searchFilter);
      Log.debug(typeof (this.searchFilter));

    }
  }


  unauthDialog() {
    let message = $localize`:@@operationLog_operator_unauth_message:Non sei autorizzato ad eseguire questa operazione`;
    let header = $localize`:@@operationLog_operator_unauth_header:Errore`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { message, header },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {

    });
  }

  censorData(data) {
    // Regular expression to extract everything from the third word to "for"
    const regex1 = /^(?:\S+\s+){2}(.+?)\s+for\b/;

    // Regular expression to extract everything between "user" and "created"
    const regex2 = /user\s+(.*?)\s+created/;


    if (this.isService) {

      for (let i = 0; i < data.length; i++) {
        if (data[i].operation == "create-user-owner-rel" || data[i].operation == "update-user-owner-rel") {
          const words = data[i].data.split(' ');

          // Censor all words except the last one
          for (let j = 0; j < words.length - 1; j++) {
            words[j] = StringHelper.censorString(words[j]);
          }

          // Join the words back into a string
          data[i].data = words.join(' ');

        } else if (data[i].operation === "create-update-method") {
          const inputString = data[i].data;

          // Process the first part (words after the first two words until "for")
          const match1 = inputString.match(regex1);
          if (match1) {
            const part1 = match1[1];
            const words = inputString.split(' ');
            // If the second and third words are identical and equal to part1...
            if (words.length > 2 && words[1] === words[2] && words[1] === part1) {
              // Find the first occurrence
              const firstIndex = inputString.indexOf(part1);
              // Find the second occurrence by searching after the first one
              const secondIndex = inputString.indexOf(part1, firstIndex + part1.length);
              if (secondIndex !== -1) {
                // Replace only at the second occurrence
                data[i].data =
                  inputString.substring(0, secondIndex) +
                  StringHelper.censorString(part1) +
                  inputString.substring(secondIndex + part1.length);
              }
            } else {
              // Otherwise, use the regular replacement (which replaces the first occurrence)
              data[i].data = inputString.replace(part1, StringHelper.censorString(part1));
            }
          }

          // Process the second part (the words between "user" and "created")
          const match2 = inputString.match(regex2);
          if (match2) {
            const part2 = match2[1];
            data[i].data = data[i].data.replace(part2, StringHelper.censorString(part2));
          }
        }
      }

      return data;
    }
    return data;
  }

  changePage(event?: PageEvent) {

    Log.debug("changePage - pageIndex:  " + event.pageIndex);

    this.currentPage = event.pageIndex;
    this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), this.currentPage);
  }

}
